import { useEffect, useRef } from "react";

function useDidUpdateEffect(func, deps) {
  const isMountingRef = useRef(false);

  useEffect(() => {
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    if (!isMountingRef.current) {
      return func();
    } else {
      isMountingRef.current = false;
    }
  }, deps);
}

export default useDidUpdateEffect;
